import { render, staticRenderFns } from "./About_HowToCite.vue?vue&type=template&id=10d27b98&scoped=true"
import script from "./About_HowToCite.vue?vue&type=script&lang=js"
export * from "./About_HowToCite.vue?vue&type=script&lang=js"
import style0 from "./About_HowToCite.vue?vue&type=style&index=0&id=10d27b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d27b98",
  null
  
)

export default component.exports